import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../api.service';
import { Entity } from '../select-list/select-list.component';
import { MyUtility } from '../../comparison';

@Component({
  selector: 'app-specimen-locations',
  templateUrl: './specimen-locations.component.html',
  styleUrls: ['./specimen-locations.component.css']
})
export class SpecimenLocationsComponent implements OnInit {
  public title : string;
  constructor(public api : ApiService) 
  {
  }

  ngOnInit() {
  }

  get items(){
    return this.api.session.specimenLocations;
  }

  get selectedItems(){
    return this.api.session.currentCriteria.specimenLocations.selectedItems;
  }
  set selectedItems(value){
    MyUtility.scrubChildren(value);
    this.api.session.currentCriteria.specimenLocations.selectedItems = value;
  }

  clearCurrent(){
    this.api.session.currentCriteria.specimenLocations = MyUtility.deepCopy(this.api.originalCriteria.specimenLocations);
  }
}
